import Input from "../lib/Input";
import CostColumns from "../lib/CostColumns";
import OperationLayout from "../lib/OperationLayout";
import useOperationContext from "../lib/useOperationContext";
import OperationHeader from "../lib/OperationHeader";
import { components } from "@/lib/ApiSchema";

export default function MaterialCustomerProvided() {
  const { operationData: data } = useOperationContext();
  const { id, name, type } = data;

  return (
    <OperationLayout
      id={id as string}
      left={<Left name={name} type={type} />}
      right={<Right />}
    />
  );
}

function Left({
  name,
  type,
}: {
  name: string;
  type: components["schemas"]["CalculatorTypeEnum"];
}) {
  return (
    <div className="w-full flex flex-col p-2 pb-1 gap-2 items-start">
      <OperationHeader name={name} type={type} />
      <Input label="Description" keyPath={["description"]} width={390} />
    </div>
  );
}

function Right() {
  return <CostColumns />;
}
